export class MicrosoftGraphRequest{
    SecurityEnabledOnly: boolean = true;
}